<template>
    <span
        v-if="loading"
        class="book-button btn book-button--single"
    >
        <Loading />
    </span>

    <template v-else-if="errorMessage" class="error-message">
        <p>{{ errorMessage }}</p>
    </template>

    <a
        v-else-if="events[0]?.event.booking?.bookingLinkURL"
        :href="events[0].event.booking?.bookingLinkURL"
        class="book-button btn book-button--custom"
    >
        {{ defaultButtonTitle }}
    </a>

    <a
        v-else-if="events.length === 1"
        :href="events[0].bookButton.link"
        class="book-button btn book-button--single"
    >
        {{ events[0].bookButton.title || defaultButtonTitle }}
    </a>

    <template v-else-if="events.length">
        <button
            class="book-button btn book-button--multiple"
            @click="performanceListDialogRef?.open()"
        >
            {{ defaultButtonTitle }}
        </button>

        <Dialog ref="performanceListDialogRef" class="performance-popup">
            <div class="performance-popup__header">
                <h2 class="performance-popup__title">Select a Performance</h2>
            </div>
            <PerformanceList :eventId="props.eventId" />
        </Dialog>
    </template>
</template>

<script setup>
import { computed, onBeforeMount, ref } from 'vue';
import getPerformances from '../services/get-performances.mjs';
import PerformanceList from './PerformanceList.vue';
import Dialog from '../Dialog/Dialog.vue';
import { isSchoolBooking } from '../../services/performance';
import Loading from '../Loading/Loading.vue';

const props = defineProps({
    eventId: {
        type: String,
        required: true,
    }
});

const defaultButtonTitle = computed(() => {
    if (events.value[0]?.event.booking?.bookingLinkLabel) {
        // The event level booking link label exists
        return events.value[0].event.booking.bookingLinkLabel;
    }

    return isSchoolBooking(events.value[0]) ?
        'School Bookings' :
        'Get Tickets';
});

const events = ref([]);
const loading = ref(true);
const performanceListDialogRef = ref(null);
const errorMessage = ref(null);

onBeforeMount(async () => {
    try {
        events.value = await getPerformances()
            .then(perfs => perfs.filter(perf => perf.event.id === props.eventId));
    } catch (error) {
        console.error(error);
        errorMessage.value = 'Something has gone wrong, please try again later.';
        events.value = [];
    } finally {
        loading.value = false;
    }
});
</script>
